/** Site-wide contact and CTA copy — update here when client supplies final brochure details. */

export const COMPANY = {
  legalName: 'Sai Vikas Coatings Private Limited',
  shortName: 'Sai Vikas Coating',
};

/** Company brochure from `doc/profile` — served from `public/brochure.pdf`. */
export const BROCHURE_PDF = '/brochure.pdf';

export const CONTACT = {
  emailPrimary: 'info@saivikascoatings.com',
  emailLegacy: 'saivikasent@yahoo.co.in',
  phones: ['+91 9822 14 86 60', '+91 9921 51 68 80', '+91 9970 66 95 81'],
  /** WhatsApp business (no spaces in wa.me link) */
  whatsappDisplay: '+91 99706 69581',
  whatsappE164: '919970669581',
  goaPhone: '+91 92707 66117',
};

export const ADDRESSES = {
  puneOffice:
    'Sr. No. 14/13 Sai Nivas, Shahid Mangal Pandey Marg, Adarsh Colony, Belthika Nagar, Thergaon, Pune, Maharashtra 411033',
  goaOffice: 'Ganesh Kannaik H.No. 681, Housing Board, Camurlim, Goa — 403507',
  workshop: 'PMK Parking, Barne Estate, Datta Nagar, Thergaon, Pune — 411033',
};

export const whatsappHref = `https://wa.me/${CONTACT.whatsappE164}`;
